import styled from "styled-components";
import PropTypes from "prop-types";

interface ImageProps {
  readonly top?: string;
  readonly right?: string;
  readonly bottom?: string;
  readonly left?: string;
  readonly width?: string;
  readonly height?: string;
}

const Wrapper = styled.div`
  display: flex;
  height: 290px;
  justify-content: center;
  margin: 0 auto;
  max-width: calc(100vw - 40px);
  overflow: hidden;
  position: relative;
  width: 335px;
  @media only screen and (min-width: 768px) {
    height: 380px;
    max-width: 440px;
    width: initial;
    margin: 0;
  }
  @media only screen and (min-width: 1024px) {
    height: 480px;
    max-width: 555px;
  }
`;
const ImageContainer = styled.div<ImageProps>`
  position: absolute;
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  bottom: ${(props) => props.bottom};
  left: ${(props) => props.left};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  overflow: hidden;
`;
const Image = styled.img`
  object-fit: contain;
  height: 100%;
`;

function DoubleImage({
  firstImage = "",
  secondImage = "",
  altFirstImage = "",
  altSecondImage = "",
  isAutism = false,
}): JSX.Element {
  return (
    <>
      <Wrapper>
        <ImageContainer left="0" width="75%" height="100%">
          <Image src={firstImage} alt={altFirstImage} />
        </ImageContainer>
        <ImageContainer
          right={isAutism ? "-10%" : "0%"}
          bottom="6%"
          height="69%"
        >
          <Image src={secondImage} alt={altSecondImage} />
        </ImageContainer>
      </Wrapper>
    </>
  );
}

DoubleImage.propTypes = {
  firstImage: PropTypes.string,
  secondImage: PropTypes.string,
  altFirstImage: PropTypes.string,
  altSecondImage: PropTypes.string,
  isAutism: PropTypes.bool,
};

export default DoubleImage;
